import React from 'react';
import styled from 'styled-components';

import Game from '../components/game';

const PageInner = styled.div`
  max-width: 375px;
  margin: auto;
`;

const IndexPage = () => (
  <PageInner>
    <Game />
    <div id="liveticker-events" />
  </PageInner>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js